import { DateValueObject } from '@/utils/value-objects/date/date-value-object.js';

export class ProbeEventResolvedAt extends DateValueObject {}
